import { render, staticRenderFns } from "./UrbanRenewalPagination.vue?vue&type=template&id=ba3490d2"
import script from "./UrbanRenewalPagination.vue?vue&type=script&lang=js"
export * from "./UrbanRenewalPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports